document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth < 768;
  const tabs = document.querySelectorAll("[data-target]");
  const tabContents = document.querySelectorAll("[data-content]");

  const removeActiveClass = () => {
    tabContents.forEach(el => el.classList.remove("is-active", "mobile-class"));
    tabs.forEach(el => el.classList.remove("is-active", "mobile-class"));
  };

  document.querySelectorAll(".close_all_tb").forEach(btn => {
    btn.addEventListener("click", removeActiveClass);
  });

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const targetSelector = this.dataset.target;
      const target = document.querySelector(targetSelector);

      if (target) {
        removeActiveClass();
        target.classList.add("is-active");
        this.classList.add("is-active");

        if (isMobile) {
          target.classList.add("mobile-class");
          this.classList.add("mobile-class");
        }
      }
    });
  });
});


/** order tracking */
async function handleStatusCheckOrder() {
  const statusElement = document.getElementById('text-error-track');
  const orderNumber = document.getElementById('order_number').value.trim();
  const customerId = getCustomerId();  // Pass your customer ID here

  statusElement.textContent = '';
  statusElement.style.color = 'rgb(92,16,140)';

  if (!orderNumber) {
    statusElement.textContent = 'Please enter an order number';
    statusElement.style.color = 'red';
    return;
  }

  try {
    // Step 1: Get a valid token via global TokenManager
    let token = await window.TokenManager.getValidToken(customerId);
    // console.log('token', token);

    // Step 2: Track with Smartech if available
    if (typeof smartech !== 'undefined') {
      smartech('dispatch', 'track order', { orderid: orderNumber });
    }

    // Step 3: Call order API
    let response = await fetch(`https://neworder.plumgoodness.com/api/order/orderDetails/${orderNumber}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const errorHandled = await handleHttpError(response, orderNumber, statusElement, customerId);
   // if (errorHandled) return; // If error handled, exit early

    // Parse the response data once we are sure it's valid
    const orderData = await response.json();
    if (!orderData.status) throw new Error('Invalid order data');

    // Process order status in a simplified way
    const orderStatus = orderData.status.toLowerCase();
    // console.log('customer tracking clicked.....');
    if (orderStatus === 'already cancelled' || orderStatus === 'already cancel') {
      statusElement.textContent = 'Already Cancelled or Not a Valid Order Number';
      statusElement.style.color = 'red';
    } else if (orderStatus === 'unfulfilled') {
      statusElement.textContent = `Hey ${orderData.shipment_name || 'there'}! Your order hasn't shipped yet. We're working hard to get your package to you ASAP.`;
      statusElement.style.color = 'rgb(92,16,140)';
    }else if (orderStatus === 'fulfilled' && orderData.displayStatus === 'DELIVERED'){
      statusElement.textContent = 'The order has already been delivered.';
      statusElement.style.color = 'rgb(92,16,140)';
    }else if ((orderStatus === 'fulfilled' && orderData.financial_status === 'REFUNDED') || (orderStatus === 'fulfilled' && orderData.displayStatus === 'NOT_DELIVERED')){
      statusElement.textContent = 'Your order has already been successfully returned.';
      statusElement.style.color = 'rgb(92,16,140)';
    } else if (orderStatus === 'partial' || orderStatus === 'fulfilled') {
      window.location.href = `https://plumgoodness.clickpost.in/?order_id=${orderNumber}`;
    } else {
      throw new Error('Unknown order status');
    }

  } catch (error) {
    console.error('Order check failed:', error);
    statusElement.textContent = 'Please double check your order ID try again.';
    statusElement.style.color = 'red';
  }
}
/** end order tracking */

/** order issue */
document.addEventListener('DOMContentLoaded', () => {
  const accordionHeads = document.querySelectorAll('.accordian_head');

  accordionHeads.forEach(head => {
    head.addEventListener('click', function () {
        // Toggle a class on the clicked element itself
      this.classList.toggle('active');

        // Optionally, toggle a class on a target inside the clicked element
      const target = document.querySelector('#popup-content-pu'); // Adjust selector for the target element
      if (target) {
          target.classList.toggle('expanded');
      }
    });
  });
});
/** end order issue */




